import step1 from '../assets/1.jpg'
import step2 from '../assets/2.jpg'
import step3 from '../assets/3.jpg'
import step4 from '../assets/4.jpg'
import step5 from '../assets/5.jpg'

export const HOW_GOUSTO_MENU_WORDS = {
  heading: 'How does the Gousto menu work?',
  steps: [
    {
      src: step1,
      alt: 'Enjoy variety: Different recipes from our menu served in the table',
      title: 'Enjoy variety',
      paragraph: 'Our menu changes weekly, keeping every week exciting.',
    },
    {
      src: step2,
      alt: 'Choose 2-5 recipes: Customer browsing the Gousto menu',
      title: 'Choose between 2-5 recipes',
      paragraph: 'You can change how many recipes each week.',
    },
    {
      src: step3,
      alt: 'Filter for your household: Menu categories like Quick and Easy, Vegetarian, Calorie Controlled, Healthy Choices and Everyday Favourites.',
      title: 'Filter for your household',
      paragraph: 'From veggie recipes, healthy choices, family-friendly meals and more.',
    },
    {
      src: step4,
      alt: 'Cater to dietary preferences: An Indian-Style Beans With Fried Egg And Sweet Potato Wedges recipe which suits dietary needs.',
      title: 'Cater to dietary preferences',
      paragraph: 'Dairy free and gluten free categories to cater for allergies.',
    },
    {
      src: step5,
      alt: 'Check ingredients: Open Recipe card in the menu displaying all the ingredients that come with the recipe.',
      title: 'Check ingredients',
      paragraph: 'Click on recipes to see what will be delivered in your box.',
    },
  ],
  ctaText: 'Try Gousto with 50% off',
}
